import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAppleComponent } from './simple-icons-apple.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAppleComponent ],
    exports:      [ SimpleIconsAppleComponent ],
    bootstrap:    []
})
export class SimpleIconsAppleModule {}
